import { WebStorageStateStore } from 'oidc-client-ts';

const region = "us-east-1";
const userPoolId = "xWwB3Yglp" // also update this in Okta if it changes
const identityPoolId = "a2882d3c-f870-400a-88e4-93d10d93841b";
const apiId = "pyf1tvvesi"
const clientId = "1mduhgv234t07sitagoojuf3a3"

const cognitoAuthConfig = {
    region: region,
    authority: `https://cognito-idp.${region}.amazonaws.com/${region}_${userPoolId}`,
    apiUrl: `https://${apiId}.execute-api.${region}.amazonaws.com/prod`,
    client_id: clientId,
    userPoolId: `${region}_${userPoolId}`,
    identityPoolId: `${region}:${identityPoolId}`,
    redirect_uri: window.location.origin,
    response_type: "code",
    scope: "aws.cognito.signin.user.admin email openid profile",
    userStore: new WebStorageStateStore({ store: window.localStorage })
};

export default cognitoAuthConfig;